module.exports = __webpack_public_path__ + "img/dropshadow.c76053e8.png";